import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { initializeDuperbrowse, openDuperbrowse, exitDuperbrowse, setCurrentItem, setCurrentStreamAndItem, shutdownDuperbrowse, exitDuperbrowseResorationTimeout, loadDuperbrowseItem } from './actionCreators';
import { reduxKey, initialState } from './constants';
import history from '../../redux/routing/history';
import { initDeviationPage } from '../../DeviationPage/redux/actions';
const actionHandler = handleActions({
    [initializeDuperbrowse.toString()]: (state, { payload: { initialStream, enableHistoryManagement } })=>_object_spread_props(_object_spread({}, state), {
            rootStream: initialStream,
            lastViewedItem: undefined,
            isHistoryManagementEnabled: enableHistoryManagement !== null && enableHistoryManagement !== void 0 ? enableHistoryManagement : true
        }),
    [openDuperbrowse.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            streamStack: [
                payload,
                ...state.streamStack
            ],
            isSessionActive: true,
            rootLocation: state.isSessionActive ? state.rootLocation : _object_spread({}, history.location),
            lastViewedItem: undefined
        }),
    [exitDuperbrowse.toString()]: (state)=>{
        const [topStream, ...restStack] = state.streamStack;
        return _object_spread_props(_object_spread({}, state), {
            streamStack: restStack,
            isSessionActive: restStack.length > 0,
            lastViewedItem: topStream ? {
                streamId: topStream.streamId,
                itemId: topStream.currentOpenItem
            } : undefined
        });
    },
    [exitDuperbrowseResorationTimeout.toString()]: (state)=>{
        return _object_spread_props(_object_spread({}, state), {
            lastViewedItem: undefined
        });
    },
    [shutdownDuperbrowse.toString()]: (state)=>_object_spread_props(_object_spread({}, state), {
            streamStack: [],
            isSessionActive: false,
            lastViewedItem: state.streamStack && state.streamStack.length ? {
                streamId: state.streamStack[state.streamStack.length - 1].streamId,
                itemId: state.streamStack[state.streamStack.length - 1].currentOpenItem
            } : undefined
        }),
    [setCurrentItem.toString()]: (state, { payload: { itemId } })=>{
        const { streamStack: [topStream, ...restStack], rootStream } = state;
        if (!topStream && !!rootStream) {
            return _object_spread_props(_object_spread({}, state), {
                rootStream: _object_spread_props(_object_spread({}, rootStream), {
                    currentOpenItem: itemId
                })
            });
        }
        const stream = state.streamStack[0];
        if (!stream) {
            return state;
        }
        const updatedStream = _object_spread_props(_object_spread({}, stream), {
            currentOpenItem: itemId
        });
        return _object_spread_props(_object_spread({}, state), {
            streamStack: [
                updatedStream,
                ...restStack
            ]
        });
    },
    [setCurrentStreamAndItem.toString()]: (state, { payload: { streamId, itemId } })=>{
        const streamIndex = state.streamStack.findIndex((st)=>st.streamId === streamId);
        const stream = streamIndex < 0 ? undefined : state.streamStack[streamIndex];
        if (stream) {
            // pop all the other potential streams, and set to specified item
            const newStack = [
                _object_spread_props(_object_spread({}, stream), {
                    currentOpenItem: itemId
                }),
                ...state.streamStack.slice(streamIndex + 1)
            ];
            return _object_spread_props(_object_spread({}, state), {
                streamStack: newStack
            });
        }
        if (state.rootStream && state.rootStream.streamId === streamId) {
            return _object_spread_props(_object_spread({}, state), {
                streamStack: [],
                isSessionActive: false,
                rootStream: _object_spread_props(_object_spread({}, state.rootStream), {
                    currentOpenItem: itemId
                })
            });
        }
        return state;
    },
    [loadDuperbrowseItem.toString()]: (state, { payload: { itemSchema } })=>{
        if (itemSchema !== 'deviation') {
            return state;
        }
        var _state_loadCount;
        return _object_spread_props(_object_spread({}, state), {
            loadCount: ((_state_loadCount = state.loadCount) !== null && _state_loadCount !== void 0 ? _state_loadCount : 0) + 1
        });
    },
    [initDeviationPage.toString()]: (state, { payload: { biMetadata, deviation } })=>{
        return _object_spread_props(_object_spread({}, state), {
            currentBiMetadata: _object_spread_props(_object_spread({}, state.currentBiMetadata), {
                [deviation.deviationId]: biMetadata
            })
        });
    }
}, initialState);
export default {
    [reduxKey]: actionHandler
};
